import { Layout } from "antd";
import Header from "layouts/developerPortal/header";
import AppMenu from "layouts/developerPortal/menu";
import styled from "styled-components";

const StyledContent = styled(Layout.Content)`
  padding: 8px 24px 24px 24px;
  height: calc(100vh - 64px);
  margin-top: 64px;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

function PageLayout({ children }) {
  return (
    <Layout>
      <Header />
      <Layout>
        <AppMenu />
        <StyledContent>{children}</StyledContent>
      </Layout>
    </Layout>
  );
}

export default PageLayout;
